import React, { useState } from 'react';
import { PageHeading, SubHeading } from 'web-ui-components/lib/typography/headings';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { GenericDivider } from 'web-ui-components/lib/layout/content';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Terms from './components/Terms';
import Submit from '../../components/Submit';

const getBulletItems = (
  altBusinessAccountSubheading1ContentA,
  altBusinessAccountSubheading1ContentB,
  dailyLimit,
  openBusinessAccountSmallBusinessText,
  transactionLimit,
  openBusinessAccountMediumBusinessText,
  openBusinessAccountTransactionText
) => {
  const items = [altBusinessAccountSubheading1ContentA, altBusinessAccountSubheading1ContentB];

  if (dailyLimit) {
    items.push(`${openBusinessAccountSmallBusinessText} ${dailyLimit}`);
    transactionLimit && items.push(`${openBusinessAccountMediumBusinessText} ${transactionLimit}`);
  } else if (transactionLimit) {
    items.push(
      `${openBusinessAccountMediumBusinessText} ${transactionLimit} ${openBusinessAccountTransactionText}`
    );
  }

  return items;
};

const ALtBusinessAccountPage = ({
  bankId,
  saveAltBusinessAccountForm,
  getBusinessData,
  isTermsChecked,
  onConfirmationCheckboxChange,
  dailyLimit,
  transactionLimit,
  termsConditionsRef,
  tariffGuideRef,
  fscsRef
}) => {
  const [isFormSubmit, formSubmitted] = useState(false);
  return (
    <Form
      onSubmit={values => {
        formSubmitted(true);
        values.altBusinessAccountTermsAgreement && saveAltBusinessAccountForm(values);
      }}
      initialValues={getBusinessData}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <Content>
              {({
                browserNewWindow,
                altBusinessAccountPageTitle,
                altBusinessAccountLeadPara,
                altBusinessAccountSectionTitlePre,
                altBusinessAccountSectionTitleUrlVM,
                altBusinessAccountSectionTitleUrlTitle,
                altBusinessAccountSectionTitlePost,
                altBusinessAccountSubheading1,
                altBusinessAccountSubheading1ContentA,
                altBusinessAccountSubheading1ContentB,
                altBusinessAccountSubheading2,
                altBusinessAccountSubheading2ContentA,
                altBusinessAccountSubheading2ContentB,
                altBusinessAccountSubheading2ContentC,
                altBusinessAccountSubheading2ContentD,
                altBusinessAccountSubheading2ContentE,
                altBusinessAccountSubheading2ContentF,
                altBusinessAccountSubheading2ContentG,
                altBusinessAccountSubheading2ContentGUrl,
                altBusinessAccountSubheading2ContentGUrlTitle,
                altBusinessAccountSubheading2ContentH,
                altBusinessAccountSubheading3,
                altBusinessAccountSubheading3ContentA,
                altBusinessAccountSubheading3ContentB,
                altBusinessAccountSubheading3ContentC,
                altBusinessAccountSubheading3ContentPre,
                altBusinessAccountSubheading4,
                altBusinessAccountSubheading4ContentA,
                altBusinessAccountSubheading4ContentB,
                altBusinessAccountSubheading4ContentC,
                altBusinessAccountSubheading4ContentD,
                altBusinessAccountSubheading4ContentE,
                altBusinessAccountSubmit,
                altBusinessAccountCancel,
                altBusinessAccountSubheading2ContentGLeaflet,
                altBusinessAccountSubheading2ContentGUrlLeafletCB,
                altBusinessAccountSubheading2ContentGUrlTitleLeaflet,
                openBusinessAccountSmallBusinessText,
                openBusinessAccountMediumBusinessText,
                openBusinessAccountTransactionText
              }) => (
                <div>
                  <PageHeading>{altBusinessAccountPageTitle} </PageHeading>
                  <StandardBody>
                    <p>
                      <strong>{altBusinessAccountLeadPara}</strong>
                    </p>
                  </StandardBody>
                  <GenericDivider />
                  <div className="c-m-section-heading u-margin-top-2 u-margin-bottom-2">
                    <SubHeading>
                      {altBusinessAccountSectionTitlePre}
                      <a href={termsConditionsRef} target="_blank" rel="noopener noreferrer">
                        {altBusinessAccountSectionTitleUrlTitle}
                      </a>
                      {altBusinessAccountSectionTitlePost}
                    </SubHeading>
                  </div>
                  <SubHeading>{altBusinessAccountSubheading1}</SubHeading>
                  <BulletList
                    items={getBulletItems(
                      altBusinessAccountSubheading1ContentA,
                      altBusinessAccountSubheading1ContentB,
                      dailyLimit,
                      openBusinessAccountSmallBusinessText,
                      transactionLimit,
                      openBusinessAccountMediumBusinessText,
                      openBusinessAccountTransactionText
                    )}
                  />
                  <SubHeading>{altBusinessAccountSubheading2}</SubHeading>
                  <StandardBody>
                    <p>
                      <strong>{altBusinessAccountSubheading2ContentA}</strong>
                    </p>
                  </StandardBody>
                  <BulletList
                    items={[
                      altBusinessAccountSubheading2ContentB,
                      altBusinessAccountSubheading2ContentC,
                      altBusinessAccountSubheading2ContentD,
                      altBusinessAccountSubheading2ContentE,
                      altBusinessAccountSubheading2ContentF,
                      <span>
                        {altBusinessAccountSubheading2ContentG}
                        <WebsiteLink
                          url={altBusinessAccountSubheading2ContentGUrl}
                          linkTitle={browserNewWindow}
                          linkText={altBusinessAccountSubheading2ContentGUrlTitle}
                          willOpenNewWindow
                        />
                        {altBusinessAccountSubheading2ContentGLeaflet}
                        <WebsiteLink
                          url={altBusinessAccountSubheading2ContentGUrlLeafletCB}
                          linkTitle={browserNewWindow}
                          linkText={altBusinessAccountSubheading2ContentGUrlTitleLeaflet}
                          willOpenNewWindow
                        />
                        .
                      </span>,
                      altBusinessAccountSubheading2ContentH
                    ]}
                  />
                  <SubHeading>{altBusinessAccountSubheading3}</SubHeading>
                  <BulletList
                    items={[
                      <WebsiteLink
                        url={termsConditionsRef}
                        linkTitle={browserNewWindow}
                        linkText={altBusinessAccountSubheading3ContentA}
                        willOpenNewWindow
                      />,
                      <WebsiteLink
                        url={tariffGuideRef}
                        linkTitle={browserNewWindow}
                        linkText={altBusinessAccountSubheading3ContentB}
                        willOpenNewWindow
                      />,
                      <WebsiteLink
                        url={fscsRef}
                        linkTitle={browserNewWindow}
                        linkText={altBusinessAccountSubheading3ContentC}
                        willOpenNewWindow
                      />
                    ]}
                  />
                  <StandardBody>
                    <p>
                      {altBusinessAccountSubheading3ContentPre}
                      <WebsiteLink
                        url={altBusinessAccountSectionTitleUrlVM}
                        linkText={altBusinessAccountSectionTitleUrlTitle}
                        willOpenNewWindow
                      />
                    </p>
                  </StandardBody>
                  <SubHeading>{altBusinessAccountSubheading4}</SubHeading>
                  <BulletList
                    items={[
                      altBusinessAccountSubheading4ContentA,
                      altBusinessAccountSubheading4ContentB,
                      altBusinessAccountSubheading4ContentC,
                      altBusinessAccountSubheading4ContentD,
                      altBusinessAccountSubheading4ContentE
                    ]}
                  />
                  <Terms
                    isTermsChecked={isTermsChecked}
                    onConfirmationCheckboxChange={onConfirmationCheckboxChange}
                    isFormSubmit={isFormSubmit}
                  />
                  <Submit submitButtonText={altBusinessAccountSubmit} disabled={!isTermsChecked} />
                  <StandardBody>
                    <p className="u-margin-2">
                      <strong>{altBusinessAccountCancel}</strong>
                    </p>
                  </StandardBody>
                </div>
              )}
            </Content>
          </div>
        </form>
      )}
    />
  );
};

ALtBusinessAccountPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveAltBusinessAccountForm: PropTypes.func.isRequired
};
export default ALtBusinessAccountPage;
